import { store } from '@common/store/store';
import { componentStore } from "@common/componentStore/componentStore";

let settingsEditorStore = {
    namespaced: true,
    state: {
        openedEditors: {},
        visibleEditorId: false,
        editorOpenedFormCrc: false
    },
    getters: {},
    mutations: {
        openEditor(state, payload) {
            if (!payload.component) return;
            let cId = payload.component.cId;
            let existing = state.openedEditors[cId];
            if (!existing || payload.overwrite) state.openedEditors[cId] = payload.component;
            state.openedEditors[cId].presetView = payload?.options?.presetView;
        },
        closeEditor(state, component) {
            delete state.openedEditors[component.cId];
            if (state.visibleEditorId === component.cId) state.visibleEditorId = false;
        },
        setVisibleEditor(state, options) {
            if (!options || !options.cId) state.visibleEditorId = false;
            else if (options.toggle && state.visibleEditorId === options.cId) state.visibleEditorId = false;
            else state.visibleEditorId = options.cId;
        },
        closeAllEditors(state) {
            state.visibleEditorId = false;
            state.openedEditors = {};
        }
    },
    actions: {
        getEditor({ commit }, options) {
            // load a temp component for animation
            let tmpComp = {
                cId: options.cId,
                loading: true // this will be overwritten (removed) when true component config is loaded
            };
            commit('openEditor', { component: tmpComp, options });
            // get true component settings
            componentStore.getConfig(options.cId).then((result) => {
                if (result) {
                    result.previewId = options.previewId;
                    commit('openEditor', { component: result, overwrite: true, options });
                    commit('setVisibleEditor', options);
                }
            });
        },
        getEditorFromCrc({ state, dispatch }, cId) {
            if (state.editorOpenedFormCrc) return;
            state.editorOpenedFormCrc = true;
            let options = {
                cId: cId,
                previewId: false,
                toggle: true
            };
            dispatch('getEditor', options);
        },
    }
};

store.registerModule('settingsEditorStore', settingsEditorStore);
export { settingsEditorStore };
